export interface Crumb
{
    translation: string;
    routerLink?: any[]|string|null|undefined;
}
